var render = function render(_c,_vm){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"8","height":"8","viewBox":"0 0 8 8"}},[_c('path',{attrs:{"fill":"currentColor","d":"M7.663.326a1.109 1.109 0 00-1.57 0L4 2.426 1.9.326a1.11016 1.11016 0 00-1.57 1.57l2.1 2.1-2.1 2.1a1.11016 1.11016 0 001.57 1.57l2.1-2.1 2.1 2.1a1.11016 1.11016 0 001.57-1.57l-2.1-2.1 2.1-2.1a1.119 1.119 0 00-.007-1.57z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }